import { render, staticRenderFns } from "./verPublicaciones.vue?vue&type=template&id=a8ea76e2"
import script from "./verPublicaciones.vue?vue&type=script&lang=js"
export * from "./verPublicaciones.vue?vue&type=script&lang=js"
import style0 from "./verPublicaciones.vue?vue&type=style&index=0&id=a8ea76e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports